export enum Paths {
  HOME_PAGE = "/",
  CATOLOG_PAGE = "/recursos",
  RESOURCE_PAGE = "/recurso/:id",
}
